import { applyMiddleware, createStore } from "redux";
import { createLogger } from "redux-logger";
import thunk from "redux-thunk";
import reducer from "../reducers/";

const logger = createLogger({
  diff: false,
  duration: true,
  timestamp: false
});

const args = process.env.NODE_ENV === "development" ? [thunk, logger] : [thunk];
const middleware = () => {
  return applyMiddleware(...args);
};

export default createStore(reducer, middleware());



// WEBPACK FOOTER //
// ./src/config/Store.js